import { LoggerService } from 'src/app/ax-commons-logger/logger/logger.service';

export class AxovaQrCode {
  public isValid: boolean;
  public type: 'project' | 'equipment' | 'screendevice' | 'eventInvitation';
  public data: {
    id?: number;
    uniqueIdentifier?: string;
    accessKey?: string;
  };

  constructor(qrcodeData: string) {
    try {
      const json = JSON.parse(qrcodeData);
      if (json.type) {
        this.type = json.type;
        this.isValid = true;
      }
      if (json.data && json.data.id) {
        this.data = {
          id: json.data.id,
        };
      }
      if (json.data && json.data.uniqueIdentifier) {
        this.data = {
          uniqueIdentifier: json.data.uniqueIdentifier,
        };
      }
      if (json.data && json.data.accessKey) {
        this.data = {
          accessKey: json.data.accessKey,
        };
      }
    } catch (qrCodeOrJsonException) {
      LoggerService.ERROR(this, 'qrCodeOrJsonException', qrCodeOrJsonException);
      this.isValid = false;
    }
  }
}
